import React from 'react'
import PropTypes from 'prop-types'
import { PUBLIC_URL } from '../helpers'
import { Code } from './Code'

export function Demo({ story, frontend, canister }) {
  const [activeTab, setActiveTab] = React.useState(0)

  const tabNames = ['App Story', 'Frontend Code', 'Canister Code']
  const tabContents = [
    <div className="story">{story}</div>,
    <Code type="frontend">{frontend}</Code>,
    <Code type="canister">{canister}</Code>,
  ]

  return (
    <div className="demo-container">
      <img
        src={`${PUBLIC_URL}/cancanScreen.jpg`}
        loading="lazy"
        alt="The 'following' screen of the CanCan UI on iPhone X"
      />
      <div className="tab-container">
        <div className="demo-tabs" role="tablist">
          {tabNames.map((tabName, index) => (
            <span
              key={tabName}
              role="tab"
              className={`demo-tab ${activeTab === index ? 'active' : ''}`}
              onClick={() => setActiveTab(index)}
            >
              {tabName}
            </span>
          ))}
        </div>
        <div className="demo-tab-content">{tabContents[activeTab]}</div>
      </div>
    </div>
  )
}

Demo.propTypes = {
  story: PropTypes.node.isRequired,
  frontend: PropTypes.node,
  canister: PropTypes.node,
}
